import React from 'react'
import { styled}  from '../../../../utilities';
import { Brutus } from '../../../../assets';
import { Avatar, withTheme } from '../../../../common';
import modules from './loading.module.scss';

const LoadingBubbles = styled
.div`
  ${({ $bubbleColor, $backgroundColor }) => ({
    backgroundColor: $backgroundColor,
      [`&>div`]: {
          backgroundColor: $bubbleColor
      }
  })}
`;

const Loading = (props = {}) => {
    const { avatar, theme } = props
    return <div className={modules.loadingWrapper}>
       {avatar && <Avatar icon={avatar} />}
        <LoadingBubbles $bubbleColor={theme.secondary} $backgroundColor={theme.background || 'transparent'} className={modules.loading}>
            {[...Array(3)].map(
                (empty, index) => <div
                    key={`loading-bubble-${index}`}
                    className={modules[`bounce${index}`]}
                />)}
        </LoadingBubbles>
    </div>
}

Loading.defaultProps = {
    avatar: Brutus
}

export default withTheme(Loading)